function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from "react";
import { Alert, Tag, Tabs, Divider, Descriptions } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { Page, Document, pdfjs } from 'react-pdf';
import Moment from "react-moment";
import Common from "./includes/Common";
import { Folder2Open, Alexa, ShareFill } from "react-bootstrap-icons";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(pdfjs.version, "/pdf.worker.js");

var DisplayFile = function DisplayFile(_ref) {
  var file_url = _ref.file_url;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      numberOfPages = _useState2[0],
      setNumberOfPages = _useState2[1];

  var _useState3 = useState(1),
      _useState4 = _slicedToArray(_useState3, 2),
      pageN = _useState4[0],
      setPageN = _useState4[1];

  var onDocumentLoadSuccess = function onDocumentLoadSuccess(_ref2) {
    var numberOfPages = _ref2.numberOfPages;
    setNumberOfPages(numberOfPages);
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: file_url != null && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("div", {
        className: "eduBkg",
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsx(Col, {
              children: /*#__PURE__*/_jsxs("div", {
                className: "tr-white",
                children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), file_url != null && /*#__PURE__*/_jsx(DocViewer, {
                  documents: [{
                    uri: Common.baseUrl + file_url
                  }],
                  pluginRenderers: DocViewerRenderers,
                  language: "fr",
                  config: {
                    header: {
                      disableHeader: false,
                      disableFileName: true
                    }
                  }
                }), /*#__PURE__*/_jsx(Divider, {})]
              })
            })
          })
        })
      })
    })
  });
};

export default DisplayFile;